import { ScopeInterface } from '@/services/Scopes/Interfaces';
import { DepartmentInterface } from '@/services/Departments/Interfaces';

export default interface RoleRepositoryInterface {
  getAllRoles(): Promise<RoleInterface[]>

  createRole(data: ApiCreateRoleInterface): Promise<boolean>

  getRoleById(roleId: string): Promise<RoleInterface>

  updateRole(data: ApiCreateRoleInterface): Promise<RoleInterface>

  deleteRole(roleId: string): Promise<void>

  changeUsersRole(users: string[], role: string): Promise<void>
}

export enum PermissionTypes {
  SCOPE,
  ROLE,
}

export interface ScopeResponseInterface {
  _id: string,
  name: string,
}

export interface RoleResponseInterface {
  _id: string,
  name: string,
}

export interface PermissionResponseInterface {
  _id: string,
  type: number,
  scope: ScopeResponseInterface,
  role: RoleResponseInterface
}

export interface RolePermissionInterface {
  _id?: string,
  id: string,
  type: number,
  scope: ScopeInterface,
  role: RoleInterface,
}

export interface RoleInterface {
  _id?: string
  id: string
  name: string
  scopes: ScopeInterface[]
  permissions: RolePermissionInterface[],
  department: DepartmentInterface
}

export interface ApiCreateRoleInterface {
  name: string,
  extensions: string[]
  scopes: string[]
  department: string
}

export interface ApiEditRoleInterface extends ApiCreateRoleInterface {
  id: string
}
